import { render, staticRenderFns } from "./lote_vencimiento.vue?vue&type=template&id=f52b5bf0&"
import script from "./lote_vencimiento.vue?vue&type=script&lang=js&"
export * from "./lote_vencimiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports